// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"styles_checkbox__eZleL","big":"styles_big__VsDho","hasError":"styles_hasError__A_VPG"};